module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving14-28d88f0fa62c77a3476a90b4a0c0adc9.jpg";